import groupBy from './groupBy';
import decodeBase64Auto from '../decode';
/**
 * Function to group and map templates by name.
 *
 * @param {Array} templates - Array of templates.
 *
 * @returns {Object}
 */

export default (templates = []) =>
  groupBy(templates, 'name')?.map(({ name, items }) => {
    const sms = items.find(({ scopeId }) => scopeId === 'SMS');
    const email = items.find(({ scopeId }) => scopeId === 'EMAIL');

    return {
      smsId: sms?.id, //only sms id to trace it, email doesn't need it.
      emailId: email?.id,
      name,
      parsedSMS: sms?.parsedContent ? decodeBase64Auto(sms?.parsedContent) : '',
      contentSMS: sms?.content ? decodeBase64Auto(sms?.content) : '',
      parsedEmail: email?.parsedContent
        ? decodeBase64Auto(email?.parsedContent)
        : '',
      contentEmail: email?.content ? decodeBase64Auto(email?.content) : '',
      emailSubject: email?.title,
    };
  });
